var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label lh-5 fw-bolder",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.titulo))]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-text text-muted",attrs:{"id":_vm.idHelp}},[_vm._v("\n    "+_vm._s(_vm.textoAjuda)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }